/* eslint-disable import/prefer-default-export */
export const initialStateUsers = {
  id: '',
  users: [],
  // Currently selected user
  selectedUser: {},
  isEditing: false,
  isLoading: false,
  initSyncInProgress: false,
  metaSyncInProgress: false,
};
